import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c54ad8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"color":"#f59a23"} }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 1,
  style: {"padding":"0 10px"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 新建分类 ")
const _hoisted_7 = {
  key: 0,
  style: {"color":"#317efd"}
}

import { CategoryService } from "@/views/material/category/category.service";
import { onMounted, ref, unref } from "vue";
import { PlusOutlined } from "@ant-design/icons-vue";
import ArrayToTree from "array-to-tree";
import { hmdConfirm } from "@/dialog/index";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    value: { default: "" }
  },
  emits: ["change", "update:value"],
  setup(__props: any, { emit: emits }) {

const props = __props as { value: string }




const TreeSelect = ref<HTMLElement | null>(null);
const selectedValue = ref<string | undefined>("");
const searchValueKey = ref("");

const selectedTreeKeys = ref<Array<string>>([]);
const expandedKeys = ref<Array<string>>([]);

const treeData = ref([]);
const treeArrData = ref([]);
const addItem = () => {
  let v = searchValueKey.value;
  hmdConfirm({
    com: import("@/views/material/category/list/category-form-btn/index.vue"),
    params: {
      categoryName: searchValueKey.value,
    },
    zIndex: 1200,
    confirm: async ({ params, res }) => {
      // console.log("🚀 ~ file: index.vue ~ line 80 ~ confirm: ~ params, res", params, res);
      await run();
      treeData.value = (unref(data) as any)?.treeRecords;
      treeArrData.value = (unref(data) as any)?.records;
      // console.log(treeData, "----------", data, res);
      selectedValue.value = res;
      selectedTreeKeys.value = [findObjByName(res)?.id];
      expandedKeys.value = getParentArr(findObjByName(res)?.id);
      // // console.log(
      //   "🚀 ~ file: index.vue ~ line 86 ~ confirm: ~ selectedValue",
      //   selectedValue,
      //   selectedTreeKeys,
      //   expandedKeys,
      //   v
      // );
      emits("update:value", findObjByName(res)?.id);
      emits("change", findObjByName(res)?.id);
    },
    close: () => {},
  });
};
const { data, run, loading } = CategoryService.useSimpleListApi();
const selectTreeData = (id, name) => {
  //   // console.log("🚀 ~ file: index.vue ~ line 45 ~ selectTreeData ~ e", e);
  selectedValue.value = name;
  if (TreeSelect.value) {
    TreeSelect.value.blur?.();
  }
  emits("update:value", id);
  emits("change", id);
};
const changeValue = () => {};
const searchValue = (v, option) => {
  // console.log("🚀 ~ file: index.vue ~ line 65 ~ v,option", v, option);
  const res: any = [];
  searchValueKey.value = v;

  if (v == "") {
    treeData.value = (unref(data) as any)?.treeRecords;
    return;
  }

  treeArrData.value.map((o: any) => {
    if (o.name.indexOf(v) > -1) {
      res.push(o);
    }
  });
  treeData.value = ArrayToTree(res || [], {
    parentProperty: "parentId",
    customID: "id",
  });
};
const findObjById: any = (id) => {
  return treeArrData.value.find((o: any) => o.id === id);
};
const findObjByName: any = (name) => {
  return treeArrData.value.find((o: any) => o.name === name);
};
const getParentArr = (id) => {
  let r: any = treeArrData.value.find((o: any) => o.id === id);
  let result = [id];
  if (!r) {
    return [];
  }
  while (r["parentId"] && r["parentId"] != "0") {
    r = treeArrData.value.find((o: any) => o.id === r["parentId"]);
    result.push(r.id);
  }

  return result;
};
onMounted(async () => {
  await run();
  treeData.value = (unref(data) as any)?.treeRecords;
  treeArrData.value = (unref(data) as any)?.records;
  // console.log(treeData, "----------", data);

  selectedValue.value = findObjById(props.value)?.name;
  selectedTreeKeys.value = [props.value];
  expandedKeys.value = getParentArr(props.value);
  // // console.log(
  //   "🚀 ~ file: index.vue ~ line 96 ~ onMounted ~ selectedTreeKeys.value",
  //   selectedTreeKeys.value,
  //   selectedValue
  // );
});

return (_ctx: any,_cache: any) => {
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    ref_key: "TreeSelect",
    ref: TreeSelect,
    value: selectedValue.value,
    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((selectedValue).value = $event)),
    placeholder: "请选择",
    onChange: changeValue,
    showSearch: "",
    onSearch: searchValue
  }, {
    dropdownRender: _withCtx(({ menuNode: menu }) => [
      (treeData.value.length > 0)
        ? (_openBlock(), _createBlock(_component_a_tree, {
            key: 0,
            class: "m-tree",
            fieldNames: { title: 'name', key: 'id', value: 'id' },
            "tree-data": treeData.value,
            selectedKeys: selectedTreeKeys.value,
            "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((selectedTreeKeys).value = $event)),
            expandedKeys: expandedKeys.value,
            "onUpdate:expandedKeys": _cache[1] || (_cache[1] = ($event: any) => ((expandedKeys).value = $event)),
            blockNode: true
          }, {
            title: _withCtx(({ name, id }) => [
              _createElementVNode("div", {
                onClick: ($event: any) => (selectTreeData(id, name))
              }, [
                (name.indexOf(searchValueKey.value) > -1 && searchValueKey.value != '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                      _createTextVNode(_toDisplayString(name.substr(0, name.indexOf(searchValueKey.value))) + " ", 1),
                      _createElementVNode("span", _hoisted_3, _toDisplayString(searchValueKey.value), 1),
                      _createTextVNode(" " + _toDisplayString(name.substr(name.indexOf(searchValueKey.value) + searchValueKey.value.length)), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(name), 1))
              ], 8, _hoisted_1)
            ]),
            _: 1
          }, 8, ["tree-data", "selectedKeys", "expandedKeys"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, "没有查询结果")),
      _createVNode(_component_a_divider, { style: {"margin":"4px 0"} }),
      _createElementVNode("div", {
        class: "select-add",
        style: {"padding":"4px 8px","cursor":"pointer"},
        onMousedown: _cache[2] || (_cache[2] = (e) => e.preventDefault()),
        onClick: addItem
      }, [
        _createVNode(_unref(PlusOutlined)),
        _hoisted_6,
        (treeData.value.length == 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, " \"" + _toDisplayString(searchValueKey.value) + "\" ", 1))
          : _createCommentVNode("", true)
      ], 32)
    ]),
    _: 1
  }, 8, ["value"]))
}
}

})